<style lang="stylus">
.secondary-header {
  height: 56px !important;

  .view-as.anchor {
    a {
      color: black !important;

      &::hover {
        color: black !important;
      }
    }
  }

  a {
    padding-right: 5px;
    font-size: 14px;
    font-weight: 500;

    img {
      height: 23px;
      width: 23px;
      vertical-align: middle;
    }
  }
}

.v-btn--active:before, .v-btn:focus:before, .v-btn:hover:before {
  background-color: transparent !important;
}

.menu-button.v-btn:hover {
  background-color: transparent !important;
}

.menu-button.v-btn:hover .v-btn__overlay {
  opacity: 0 !important;
}

.menu-button.v-btn .v-btn__overlay {
  opacity: 0 !important;
}

.menu-button.v-btn .v-btn__content {
  position: relative;
  z-index: 1;
}

.menu-button.theme--light.v-btn:not(.v-btn--icon):not(.v-btn--flat) {
  background-color: #fff;
}

.secondary-header .v-btn {
  margin-right: 1em !important;
}

.secondary-header .v-btn:hover {
  img {
    color: #fec832 !important;
  }
}

.menu-button.v-btn {
  border-bottom: 8px solid #fff !important;
  text-decoration: none;
  padding-right: 0px;
  padding-left: 0px;
  min-width: 0;
  position: relative;
  overflow: visible !important;
}

.menu-button.v-btn .v-btn__content {
  position: relative;
}

.menu-button.v-btn .v-btn__content::after {
  content: '';
  position: absolute;
  bottom: -24px;
  left: 0;
  width: 0;
  height: 10px;
  background: #fec832;
  transition: width 0.3s ease;
  z-index: 1000;
  pointer-events: none;
}

.menu-button.v-btn:hover .v-btn__content::after {
  width: 100% !important;
}

/* Fallback for direct button pseudo-element */
.menu-button.v-btn::after {
  content: '';
  display: block;
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 0;
  height: 8px;
  background: #fec832;
  transition: width 0.3s ease;
  z-index: 1000;
  pointer-events: none;
}

.menu-button.v-btn:hover::after {
  width: 100% !important;
}

.logout {
  @media (min-width: 960px) and (max-width: 1263px) {
    padding-bottom: 30px;
  }
}

.logoutmd {
  @media (min-width: 960px) and (max-width: 1263px) {
    right: -100px !important;
  }
}

.view-as-list {
  padding: 4px;
  background: white;
  cursor: pointer;

  a {
    height: 21px;
    padding: 4px;
    font-weight: 500;
  }
}

.view-as-list.v-list:hover {
  background: #ffc627;
}

.v-menu__content.theme--light {
  border-radius: 5px !important;
}

.v-toolbar__content {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.v-toolbar {
  background-color: white !important;
}

.nav-item-link {
  margin-bottom: -12px;
  font: normal normal normal 16px / 22px Arial !important;
  /* The hover bar is positioned off .v-btn__content, so every label must be the
     same height. Help is a <span> and missed the 5px the <a> labels get. */
  padding: 5px;
}

/* Fix text transform for buttons to prevent all caps */
.v-btn {
  text-transform: none !important;
}
</style>

<template>
  <div class="secondary-header">
    <v-dialog v-model="dialog" max-width="640" role="dialog" aria-labelledby="dialog-title">
      <v-card>
        <v-card-title id="dialog-title" class="headline">Select a student</v-card-title>
        <v-container class="container">
          <v-row no-gutters wrap align-center>
            <v-col cols="6" md="6">
              <v-text-field
                v-model="asurite"
                label="ASURITE or Email"
                variant="underlined"
                placeholder="Please type the ASURITE or email here"
                required
                @keyup.enter="viewAsDialog"
                ref="alias"
              />
            </v-col>
            <v-col cols="2" md="2" class="d-flex justify-center align-center">
              <v-btn variant="flat" color="#8c1d40" class="text-white" :disabled="!asurite" @click="viewAsDialog"
                >View</v-btn
              >
            </v-col>
            <v-col cols="2" md="2" class="d-flex justify-center align-center">
              <v-btn variant="outlined" class="text-black" @click="dialog = false">Cancel</v-btn>
            </v-col>
            <v-col cols="2" md="2" />
            <v-col cols="12" md="12">
              <span class="subheading text-error" v-if="notfound"
                >{{ isEmailInput ? 'Email' : 'ASURITE' }} not found!</span
              >
              <span class="subheading text-error" v-if="invalidAsurite">
                Invalid {{ isEmailInput ? 'email address' : 'ASURITE' }}!
              </span>
              <span class="subheading text-error" v-if="duplicateEmail">
                Multiple contacts share this email address. Please contact support to resolve the duplicate records.
              </span>
              <span class="subheading text-error" v-if="notAuthorized">
                You are not authorized to view this learner.
              </span>
              <span class="subheading text-error" v-if="enterOriginalAsurite">
                You have entered your {{ isEmailInput ? 'email' : 'asurite' }}. Please use
                <strong> Stop view as</strong> option to view your details.
              </span>
            </v-col>
          </v-row>
        </v-container>
        <v-card-text class="text-caption font-weight-regular">
          Note: You may view information for students using their ASURITE UserID or the email address on their learner
          application. The page displays a dashboard view for the student. Most links from this view take you to your
          details and not the student's information.
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-toolbar class="container pa-0 bg-white" role="navigation" aria-label="Secondary navigation">
      <v-toolbar-items class="d-none d-md-flex" v-if="isAuthenticated">
        <v-btn
          variant="text"
          :ripple="false"
          @click="asuoDataLayerClick('SecondaryHeaderComponent', '0', '')"
          :style="{ borderBottom: navigation == 'dashboard' ? '8px solid #ffc627 !important' : '8px solid #fff' }"
          class="menu-button"
        >
          <router-link to="/dashboard" class="nav-item-link">Dashboard</router-link>
        </v-btn>
        <v-btn
          variant="text"
          :ripple="false"
          :style="{
            borderBottom:
              navigation == 'courseHistory' || navigation == 'courseHistoryV2'
                ? '8px solid #ffc627 !important'
                : '8px solid #fff'
          }"
          @click="asuoDataLayerClick('SecondaryHeaderComponent', '2', '')"
          class="menu-button"
        >
          <router-link to="/my-courses" class="nav-item-link">My Courses</router-link>
        </v-btn>
        <v-btn
          variant="text"
          :ripple="false"
          :style="{
            borderBottom:
              navigation == 'addCourses' || navigation == 'addCoursesV2'
                ? '8px solid #ffc627 !important'
                : '8px solid #fff'
          }"
          @click="asuoDataLayerClick('SecondaryHeaderComponent', '1', '')"
          class="menu-button"
        >
          <router-link to="/courses-add" class="nav-item-link">Add Courses</router-link>
        </v-btn>
        <v-btn
          v-if="isPartnerSwitcherEnabled"
          variant="text"
          :ripple="false"
          :style="{ borderBottom: navigation == 'adminOnly2026' ? '8px solid #ffc627 !important' : '8px solid #fff' }"
          @click="asuoDataLayerClick('SecondaryHeaderComponent', '9', '')"
          class="menu-button"
        >
          <router-link to="/adminonly/2026" class="nav-item-link">Admin</router-link>
        </v-btn>
        <v-btn
          variant="text"
          :ripple="false"
          :style="{ borderBottom: navigation == 'profile' ? '8px solid #ffc627 !important' : '8px solid #fff' }"
          @click="asuoDataLayerClick('SecondaryHeaderComponent', '8', '')"
          class="menu-button"
        >
          <router-link to="/profile" class="nav-item-link">Profile</router-link>
        </v-btn>
        <v-btn :ripple="false" variant="text" @click="navigateToHelp()" class="menu-button">
          <span class="nav-item-link">Help</span>
        </v-btn>

        <div class="d-flex flex-column justify-end align-center me-24">
          <div class="mb-1" v-if="adminName">
            {{ adminName }}
          </div>

          <v-btn
            :ripple="false"
            variant="flat"
            color="#fec627"
            class="text-black my-1"
            style="width: 8rem; height: 20px"
            v-if="beforeViewAs && originalAdmin"
            @click="
              dialog = !dialog;
              setfocus();
            "
          >
            View as
          </v-btn>

          <v-menu offset-y v-if="!beforeViewAs && !!originalAsurite">
            <template v-slot:activator="{ props }">
              <v-btn
                v-bind="props"
                variant="flat"
                color="#fec627"
                class="text-black my-1"
                style="width: 8rem; height: 20px"
              >
                View as&nbsp; <v-icon class="mt-0" size="16">mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in views"
                :key="index"
                @click="viewAsOrRemove(item)"
                class="font-weight-bold text-center"
              >
                <v-list-item-title>{{ item }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>

        <v-btn
          variant="flat"
          :ripple="false"
          color="#8c1d40"
          class="logoutmd rounded-pill text-white position-absolute"
          style="right: 0px; height: 32px; margin-right: 0px !important; margin-top: 15px"
          :class="!!originalAsurite ? 'logout' : ''"
          @click="asuoDataLayerClick('SecondaryHeaderComponent', '5', '')"
          aria-label="Logout from application"
        >
          <span @click="doLogOut()" class="font-weight-bold"> Logout </span>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
  </div>
</template>

<script>
import { defineComponent, nextTick } from 'vue';
import { useAuthStore } from '@/stores/auth';
import { useUiStore } from '@/stores/ui';
import { useUserStore } from '@/stores/user';
import { useViewAsStore } from '@/stores/viewAs';

import { DataLayerMixin } from '../mixins/dataLayerMixin.js';
import { refreshMinorConsentStatus, refreshHsGradDateStatus } from '../mixins/sessionInitializer';
import { AjaxLoader } from '../mixins/ajaxLoader';
import { Logger } from '../mixins/logger';
import { Helper } from '../mixins/helpers';
import { isFeatureEnabled } from '../../feature-flags.js';

export default defineComponent({
  emits: ['refreshDashboard', 'updateAdminUserName'],
  name: 'SecondaryHeaderComponent',

  data() {
    return {
      dialog: false,
      asurite: '',
      originalAsurite: '',
      originalEmail: '',
      // ACC-228: the admin's own learnerId, captured before getLearnerDetails swaps
      // learnerData to the impersonated learner — needed as actorLearnerId when
      // starting the audited impersonation session.
      originalLearnerId: '',
      originalAdmin: false,
      admin: false,
      overrideUserName: '',
      notfound: false,
      invalidAsurite: false,
      duplicateEmail: false,
      notAuthorized: false,
      enterOriginalAsurite: false,
      views: ['View as', 'Stop view as'],
      beforeViewAs: true,
      viewAsRestoreAttempted: false
    };
  },

  mounted() {
    // Set up polling to check for learner data when component mounts
    this.checkForLearnerData();
  },

  mixins: [Helper, DataLayerMixin, AjaxLoader, Logger],

  props: {
    nav: String,
    adminUserName: String,
    isPathwaysAllowed: Boolean
  },

  computed: {
    isAuthenticated() {
      // Use Pinia store's built-in getter for reactivity
      const authStore = useAuthStore();
      return authStore.isAuthenticated;
    },
    isNotInRegisterationPage() {
      // Check if current route is NOT in registration/login flow
      const route = this.$route.name;
      const registrationRoutes = [
        'login',
        'WelcomeDesktop',
        'register',
        'Registerv2',
        'SignupConfirmation',
        'ConfirmRegistrationv2',
        'error'
      ];
      return !registrationRoutes.includes(route);
    },
    adminName() {
      return this.overrideUserName || this.adminUserName;
    },
    navigation() {
      return this.$route.name;
    },
    // Reactive computed properties for view-as functionality
    hasViewAsPermission() {
      return this.$conn?.learnerData?._viewAs && this.isAuthenticated;
    },
    learnerFullName() {
      if (this.$conn?.learnerData?._firstName && this.$conn?.learnerData?._lastName) {
        return `${this.$conn.learnerData._firstName} ${this.$conn.learnerData._lastName}`;
      }
      return '';
    },
    shouldInitializeViewAs() {
      return this.hasViewAsPermission && !this.originalAdmin && this.learnerFullName;
    },
    getTriggerViewAs() {
      const uiStore = useUiStore();
      return uiStore.triggerViewAs;
    },
    // The sticky banner asks to exit here so both exits run the same teardown.
    viewAsExitRequests() {
      return useViewAsStore().exitRequests;
    },
    viewAsRenewRequests() {
      return useViewAsStore().renewRequests;
    },
    // ULC-3125: the View As field accepts an ASURITE or an email address
    isEmailInput() {
      return (this.asurite || '').includes('@');
    },
    isPartnerSwitcherEnabled() {
      return isFeatureEnabled('PARTNER_SWITCHER');
    }
  },

  watch: {
    getTriggerViewAs() {
      this.callNewAsurite();
    },
    viewAsExitRequests() {
      this.viewAsDialog('stop');
    },
    viewAsRenewRequests() {
      this.startImpersonationAuditSession({ renew: true });
    },
    '$conn.learnerData': {
      handler(newData) {
        if (newData && newData._viewAs && !this.originalAdmin) {
          this.originalAdmin = true;
          this.restoreViewAsSession();
        }
      },
      immediate: true,
      deep: true
    },
    // Reactive watcher for view-as initialization
    shouldInitializeViewAs: {
      handler(shouldInitialize) {
        if (shouldInitialize) {
          this.originalAdmin = true;
          this.overrideUserName = this.learnerFullName;

          // The admin's own payload just landed — this is the only point where we know
          // they're allowed to view as, so it's where a persisted session resumes.
          this.restoreViewAsSession();
        }
      },
      immediate: true
    }
  },

  methods: {
    setfocus() {
      nextTick(() => this.$refs.alias.focus());
    },

    async doLogOut() {
      this.logInfo('do logout secondary header');

      this.$session.remove('contactFormModel');
      this.$session.remove('LearnerFormModel');

      // The tab outlives the logout — don't let the next login inherit the session.
      useViewAsStore().stop();

      await this.$auth.logOut();
    },

    navigateToHelp() {
      this.asuoDataLayerClick('SecondaryHeaderComponent', '4', '');

      window.open(
        Helper.methods.isUlcPartner() || Helper.methods.isAcceleratePartner(this.$conn.learnerData._partnerURLSubDomain)
          ? 'https://ulc.asu.edu/help-center/faqs/'
          : 'https://ea.asu.edu/help-center/faqs/',
        '_blank'
      );
    },

    async callNewAsurite() {
      if (!this.originalAdmin) return;

      // read params from url
      const { viewAs } = this.$route.query;

      this.asurite = viewAs;

      await this.enterViewAs({ clearQueryParams: true });
    },

    // Resume a session persisted in sessionStorage after a refresh or a full page load.
    // Only the admin who started it can resume it — a different login gets it cleared.
    async restoreViewAsSession() {
      const viewAsStore = useViewAsStore();

      // Three separate paths detect the admin payload (two watchers and the poll below);
      // whichever wins, the resume runs exactly once.
      if (this.viewAsRestoreAttempted || !viewAsStore.hasPendingSession) return;

      this.viewAsRestoreAttempted = true;

      const currentAsurite = (this.$conn.learnerData && this.$conn.learnerData._asuRite) || '';

      if (viewAsStore.actorAsurite && currentAsurite && viewAsStore.actorAsurite !== currentAsurite) {
        viewAsStore.stop();
        return;
      }

      this.asurite = viewAsStore.targetIdentifier;

      await this.enterViewAs();
    },

    // Shared by the ?viewAs= deep link and the sessionStorage restore. The dialog has
    // its own copy because it also drives the not-found/duplicate-email messaging.
    async enterViewAs({ clearQueryParams = false } = {}) {
      try {
        if (!this.asurite || this.originalAsurite === this.asurite) return;

        this.beforeViewAs = false;
        this.enterOriginalAsurite = false;

        this.$conn.setProxy = true;
        this.$conn.setProxyAsurite = this.asurite;

        this.originalAsurite = this.originalAsurite || (this.$conn.learnerData && this.$conn.learnerData._asuRite);
        // ULC-3125: capture the admin's own email here too (before getLearnerDetails swaps
        // learnerData to the impersonated learner) so the own-email guard has the right value.
        this.originalEmail = this.originalEmail || (this.$conn.learnerData && this.$conn.learnerData._emailId) || '';
        this.originalLearnerId = this.originalLearnerId || (this.$conn.learnerData && this.$conn.learnerData.learnerId);

        await this.$conn.getLearnerDetails(this.asurite);

        // A lookup can resolve without throwing (e.g. a soft-fail 200) and still bring back no
        // real learner — matches the same guard viewAsDialog() applies before starting a session.
        if (!this.$conn.learnerData.learnerId) {
          throw new Error(`No learner found for identifier: ${this.asurite}`);
        }

        this.overrideUserName = `${this.$conn.learnerData._firstName} ${this.$conn.learnerData._lastName}`;

        useViewAsStore().start(this.buildViewAsSession());

        // ACC-228: fire-and-forget — records the audited session without adding
        // latency to (or risking) the View As entry that's already succeeded above.
        this.startImpersonationAuditSession();

        // ACC-399 (#1616): re-resolve the consent gate for the viewed-as learner
        // so the admin sees the exact gate that learner would.
        await refreshMinorConsentStatus(this.$conn);
        refreshHsGradDateStatus(this.$conn);

        // clear query params
        if (clearQueryParams) this.$router.push({ query: {} });

        this.$emit('refreshDashboard');
      } catch (error) {
        this.logError('enterViewAs', error);

        // Never leave a banner claiming a session that failed to load.
        this.abortViewAs();
      }
    },

    // Read off the swapped-in learner, so the banner reflects who is actually loaded.
    // OTP learners have no ASURITE — show the email the lookup used instead.
    buildViewAsSession() {
      const learner = this.$conn.learnerData || {};

      return {
        actorAsurite: this.originalAsurite,
        targetIdentifier: this.asurite,
        targetName: this.overrideUserName,
        targetAsurite: learner._asuRite || learner._emailId || '',
        targetPartner: learner._partnerName || ''
      };
    },

    abortViewAs() {
      useViewAsStore().stop();
      useUserStore().clearImpersonationSession();

      this.$conn.setProxy = false;
      this.$conn.setProxyAsurite = '';
      this.asurite = '';
      this.beforeViewAs = true;
    },

    // ACC-228: shared by the dialog and the ?viewAs=/session-restore entry points.
    // Always resolves (never rejects), so a caller may await it or not. The banner
    // (ViewAsBanner.vue) owns enforcing/displaying the token's expiry from there.
    // renew: the admin pressed "Keep viewing" — mint a replacement even though the
    // current token is still valid.
    startImpersonationAuditSession({ renew = false } = {}) {
      const actorLearnerId = this.originalLearnerId;
      const targetLearnerId = this.$conn.learnerData && this.$conn.learnerData.learnerId;

      if (!actorLearnerId || !targetLearnerId) return;

      const userStore = useUserStore();
      const renewingSessionId = userStore.impersonationSession.sessionId;

      if (renew && (!useViewAsStore().isActive || !renewingSessionId)) return;

      // A still-valid session for this exact target survives a refresh (the store
      // rehydrates it from sessionStorage) — reuse it instead of minting a new one
      // every time restoreViewAsSession() re-enters the same View As.
      if (
        !renew &&
        userStore.getImpersonationToken &&
        String(userStore.impersonationSession.targetLearnerId) === String(targetLearnerId)
      ) {
        return;
      }

      // Wrapped in Promise.resolve().then() so even a missing/throwing
      // createImpersonationSession (never expected, but this call must be
      // bulletproof) rejects into the catch below instead of throwing
      // synchronously into the View As entry that already succeeded.
      return Promise.resolve()
        .then(() =>
          this.$conn.createImpersonationSession({
            actorLearnerId,
            targetLearnerId,
            reason: renew ? 'Learner View As (extended)' : 'Learner View As'
          })
        )
        .then((session) => {
          // A renewal that lands after an exit, logout or learner switch must not
          // overwrite (or resurrect) whatever session is current now. Logout ends View
          // As without clearing the audit session, so the session id alone isn't enough.
          if (renew && (!useViewAsStore().isActive || userStore.impersonationSession.sessionId !== renewingSessionId)) {
            return;
          }
          if (session) userStore.setImpersonationSession({ ...session, targetLearnerId });
        })
        .catch((error) => this.logError('startImpersonationAuditSession', error));
    },

    async viewAsDialog(pos) {
      // ULC-3125: capture the admin's own identifiers only while still pre-view-as, so the
      // own-identifier guard never records the impersonated learner (e.g. when the dialog is
      // opened during an active view-as started from the ?viewAs= deep link). Idempotent via ||.
      if (this.beforeViewAs) {
        this.originalAsurite = this.originalAsurite || this.$conn.learnerData._asuRite;
        this.originalEmail = this.originalEmail || this.$conn.learnerData._emailId || '';
        this.originalLearnerId = this.originalLearnerId || this.$conn.learnerData.learnerId;
      }

      this.asurite = (this.asurite || '').trim();

      // ULC-3125: accept an ASURITE or an email address (OTP learners have no ASURITE).
      // 'stop' skips validation — this.asurite still holds the viewed learner's
      // identifier, which may be an email.
      const isValidInput =
        pos === 'stop' ||
        (this.isEmailInput ? /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.asurite) : /^\w+$/gi.test(this.asurite));

      if (isValidInput) {
        if (pos === 'stop') {
          // To make below if condition true
          this.asurite = 'asurite';
        }

        // ULC-3125: the admin's own identifier can be their asurite or their email
        const isOwnIdentifier =
          this.originalAsurite === this.asurite ||
          (this.isEmailInput && this.originalEmail && this.asurite.toLowerCase() === this.originalEmail.toLowerCase());

        if (this.asurite && !isOwnIdentifier) {
          this.beforeViewAs = false;
          this.enterOriginalAsurite = false;

          try {
            const userStore = useUserStore();

            if (pos === 'stop') {
              this.asurite = this.originalAsurite;
              this.beforeViewAs = true;

              // Clear admin context when stopping View As
              userStore.clearAdminContext();
              userStore.clearImpersonationSession();
              useViewAsStore().stop();
            } else {
              // Store admin context when starting View As
              // Use the current learner data before it gets replaced
              userStore.setAdminContext(this.originalAsurite, 'Admin');

              // Drop the previous target's token, or it rides along on the new target's requests below.
              userStore.clearImpersonationSession();
            }

            this.$conn.setProxy = true;
            this.$conn.setProxyAsurite = this.asurite;

            await this.$conn.getLearnerDetails(this.asurite);

            if (!this.$conn.learnerData.learnerId) {
              throw new Error(`No learner found for identifier: ${this.asurite}`);
            }

            this.overrideUserName = `${this.$conn.learnerData._firstName} ${this.$conn.learnerData._lastName}`;

            // Persist only once the lookup succeeded, so the banner can never name a
            // learner the portal isn't actually showing.
            if (pos !== 'stop') {
              useViewAsStore().start(this.buildViewAsSession());

              // Awaited so refreshDashboard below never fires before the new target's token is in place.
              await this.startImpersonationAuditSession();
            }

            if (pos === 'stop') {
              this.asurite = this.originalAsurite = this.originalEmail = '';
              this.originalLearnerId = '';

              this.$conn.setProxy = false;
              this.$conn.setProxyAsurite = '';
            }
            this.dialog = this.notfound = false;
            this.dialog = this.invalidAsurite = false;
            this.duplicateEmail = false;
            this.notAuthorized = false;

            // ACC-399 (#1616): re-resolve the consent gate for the now-current
            // learner — the viewed-as minor on enter, the admin (none) on stop.
            await refreshMinorConsentStatus(this.$conn);
            refreshHsGradDateStatus(this.$conn);

            this.$emit('refreshDashboard');
          } catch (error) {
            this.logError('viewAsDialog', error);

            // A failed lookup must never leave the session mid-transition: $conn.setProxy was
            // already flipped true above, and App.vue/router.js read that same flag to suppress
            // the minor-consent gate — left set here, a mistyped ASURITE or a 404 would disable
            // the gate without ever completing a real impersonation. Roll every change this
            // attempt made back to "not viewing as."
            useViewAsStore().stop();
            useUserStore().clearImpersonationSession();
            this.$conn.setProxy = false;
            this.$conn.setProxyAsurite = '';
            this.beforeViewAs = true;
            if (pos !== 'stop') {
              useUserStore().clearAdminContext();
            }

            // ULC-3125: duplicate-email lookups surface as bad data, not "not found"
            // ACC-467/ULC-3181: an authorization denial is neither — the learner exists,
            // the admin just isn't allowed to view them.
            this.duplicateEmail = error?.errorCode === 'EMAIL_MULTIPLE_ASSOCIATIONS';
            this.notAuthorized = error?.errorCode === 'VIEW_AS_NOT_AUTHORIZED';
            this.notfound = !this.duplicateEmail && !this.notAuthorized;
            this.invalidAsurite = false;
          }
        } else {
          this.enterOriginalAsurite = true;
          this.notfound = false;
          this.invalidAsurite = false;
          this.duplicateEmail = false;
          this.notAuthorized = false;
        }
      } else {
        this.notfound = false;
        this.enterOriginalAsurite = false;
        this.duplicateEmail = false;
        this.notAuthorized = false;
        this.invalidAsurite = true;
      }
    },

    viewAsOrRemove(item) {
      if (item === 'View as') {
        this.dialog = !this.dialog;
        this.setfocus();
      } else if (item === 'Stop view as') {
        this.viewAsDialog('stop');
      }
    },

    checkForLearnerData() {
      // Check if learner data is available and force update if needed
      const checkInterval = setInterval(() => {
        if (this.$conn?.learnerData?._viewAs && !this.originalAdmin) {
          this.originalAdmin = true;
          this.$emit('updateAdminUserName', `${this.$conn.learnerData._firstName} ${this.$conn.learnerData._lastName}`);
          this.restoreViewAsSession();
          clearInterval(checkInterval);
        }
      }, 500); // Check every 500ms

      // Stop polling after 10 seconds to avoid infinite polling
      setTimeout(() => {
        clearInterval(checkInterval);
      }, 10000);
    }
  }
});
</script>
